<template>
    <div>
        <v-card flat>
            <v-alert dense outlined type="error" v-if="alertError">
                No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
            </v-alert>            
            <v-toolbar title elevation="1">
                <v-toolbar-title class="tituloMaquinaria">Tipos de Vehículos</v-toolbar-title>
                <v-divider vertical class="ml-3"></v-divider>    

                <v-spacer></v-spacer>      
                <v-text-field outlined class=" pr-4"
                    label="Buscar Tipo Vehículo"
                    v-model="buscarTipoVehiculo"
                    append-icon="mdi-magnify"
                    single-line
                    hide-details
                ></v-text-field>
                <v-tooltip bottom color="#0019d8" v-if="permisos.crear">
                    <template v-slot:activator="{ on }">
                        <v-btn color="#0019d8" @click="AbrirModalRegistrarTipoVehiculo()" dark rounded v-on="on">
                            <v-icon left>fas fa-save</v-icon> Crear
                        </v-btn>
                    </template>
                    <span>Nuevo Tipo Vehículo</span>
                </v-tooltip>                                      
            </v-toolbar>
            <v-data-table
                :headers="EncabezadoTablaTipoVehiculo"
                :items="ArrayTiposVehiculos"
                class="elevation-1"
                :search="buscarTipoVehiculo"
                :footer-props="{itemsPerPageText: 'Filas por página'}"                 
                :loading="loading"
                loading-text="Cargando Datos..."                                
            >
                <template v-slot:item.action="{ item }">
                    <v-tooltip left color="#d69b01">
                        <template v-slot:activator="{ on }">
                            <v-btn small class="ml-2" dark fab color="#d69b01" v-on="on" @click="AbrirModalEditarTipoVehiculo(item)">
                                <v-icon small>fas fa-edit</v-icon>
                            </v-btn>                        
                        </template>
                        <span class="fontButton">Editar Tipo Vehículo</span>
                    </v-tooltip>                                              
                    <v-tooltip left color="#D80000" v-if="permisos.eliminar">
                        <template v-slot:activator="{ on }">
                            <v-btn small class="ml-2" dark fab color="#D80000" v-on="on" @click="AbrirModalEliminarTipoVehiculo(item)">
                                <v-icon small>fas fa-trash-alt</v-icon>
                            </v-btn>                        
                        </template>
                        <span class="fontButton">Eliminar Tipo Vehículo</span>
                    </v-tooltip>                                              
                </template>            
                <template v-slot:no-results>
                    <v-alert type="warning" prominent dense outlined border="left" class="text-xs-center mx-10 mt-2 titulo">
                        Tipo de Vehículo no existe
                    </v-alert>                        
                </template>                
                <template v-slot:no-data v-if="ArrayTiposVehiculos.length === 0">
                    <v-alert dense outlined class="text-xs-center textoalerta" type="warning" prominent border="left" v-if="!alertError">
                        No existen Tipos de Vehículos registrados
                    </v-alert>
                    <v-alert dense outlined type="error" v-if="alertError">
                        No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
                    </v-alert>
                </template>                                
            </v-data-table>
        </v-card>
        <!-- mostramos el circular progress cuando carguen los datos para editar un tipo de vehiculo -->
        <v-overlay :value="EstadoCircularProgress">
            <v-progress-circular indeterminate :size="80" :width="10" color="#ffffff"></v-progress-circular>
        </v-overlay>                      
        <RegistrarTipoVehiculo 
            :AbrirDialogoRegistrarTipoVehiculo="AbrirDialogoRegistrarTipoVehiculo" @CerrarModalRegistrarTipoVehiculo="CerrarModalRegistrarTipoVehiculo"
            :esNuevo="esNuevo" :TituloDialogo="TituloDialogo" @TodosTiposVehiculos="TodosTiposVehiculos"
            :DatosEditarTipoVehiculo="DatosEditarTipoVehiculo" :EstadoPermisoEditar="EstadoPermisoEditar"
        />
        <MensajeEliminar 
            :DialogoMensajeEliminar="DialogoMensajeEliminar" @CerrarDialogoMensajeEliminar="CerrarDialogoMensajeEliminar"
            :tituloMensajeEliminar="tituloMensajeEliminar" @Eliminar="EliminarTipoVehiculo"
            :loadingEliminarHerramientaMateriaPrima="loadingEliminarTipoVehiculo" :alertError="alertError"
        />        
    </div>    
</template>

<script>
import { mapGetters, mapActions  } from 'vuex'
import { showMessageError, showMessageSuccess } from '../../../../services/sweetAlert'
import RegistrarTipoVehiculo from '../../../../components/IngresoNuevaInformacion/Tipos/TipoVehiculo/RegistrarTipoVehiculo'
import MensajeEliminar from '../../../../components/MensajeEliminar'

export default {
    props: {
        tab: String
    },

    components: {
        RegistrarTipoVehiculo,
        MensajeEliminar,
    },
    data() {
        return {
            EncabezadoTablaTipoVehiculo:[
                {text: 'Tipo Vehículo', value: 'nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Descripción', value: 'descripcion', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Acciones', value: 'action', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],                   
            buscarTipoVehiculo:'',
            ArrayTiposVehiculos:[],
            loading:false,
            alertError:false,
            //variables para los permisos del colaborador
            namespace:'oidcStore/',
            EstadoPermisoEditar: false,
            permisos:{
                crear:false,
                editar:false,
                eliminar:false
            },
            // nuevo tipo de vehiculo
            esNuevo: false,
            TituloDialogo:'',
            AbrirDialogoRegistrarTipoVehiculo: false,
            // eliminar tipo de vehiculo
            DialogoMensajeEliminar:false,
            tituloMensajeEliminar:'',
            loadingEliminarTipoVehiculo: false,
            IdTipoVehiculo: '',
            // editar tipo de vehiculo
            DatosEditarTipoVehiculo:{},
            EstadoCircularProgress:false,
        }
    },

    computed: {
        ...mapGetters('oidcStore', [
            'oidcIsAuthenticated',
            'oidcUser'
        ]),      
    },    

    watch: {
        tab(){
            if(this.tab==="tab-1")this.TodosTiposVehiculos()
        }
    },

    created() {
        this.TodosTiposVehiculos()
        this.ObtenerPermisosSubmenuUsuario()
    },

    methods: {
        // metodos para obtener los permisos del colaborador a este modulo
            ...mapActions('oidcStore', ['authenticateOidcSilent',
                    'signOutOidc', 'authenticateOidc']),
            async ObtenerPermisosSubmenuUsuario(role){
                if (this.$store.getters[this.namespace + 'oidcIsAuthenticated']) {
                    if(this.$store.getters['oidcStore/oidcUser'].role === 'Administrador'){
                            this.permisos.crear = true
                            this.permisos.editar = true
                            this.permisos.eliminar = true
                            return 0            
                    }else{
                        //preguntar al backend por los permisos del submenu del usuario
                            var url = 'tipo'
                            const response  = await this.$store.dispatch('PermisosSubMenu', url)
                            if(typeof response === 'undefined'){
                                this.alertError=true
                                this.loading=false
                                return 0
                            }                                                 
                            if(response.status === 200){
                                this.alertError= false
                                this.permisos = response.data         
                            }else if(response.status === 400){
                                showMessageError('Error 400','Petición mala')
                            }else if(response.status === 404){
                                showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                            }else if(response.status === 500){
                                showMessageError('Error 500','Error en el servidor')            
                            }
                            return 0
                    }
                }
            },                    
        // controlamos las excepciones de las peticiones al api
            ControllerException(response){
                if(typeof response === 'undefined'){
                    this.alertError=true
                    this.loading = false
                    this.EstadoCircularProgress = false
                    this.loadingEliminarTipoVehiculo = false
                    return 0
                }if(response.status === 200){
                    this.alertError= false
                    this.loading = false                    
                    if(this.TituloDialogo === "eliminar"){
                        showMessageSuccess('¡BIEN!', 'Tipo Vehículo eliminado correctamente')
                        this.TituloDialogo = ''
                        this.TodosTiposVehiculos()
                        this.loadingEliminarTipoVehiculo = false
                        this.CerrarDialogoMensajeEliminar()
                    }else if(this.TituloDialogo === "Editar"){
                        if(this.permisos.editar) this.EstadoPermisoEditar = this.permisos.editar
                        else this.EstadoPermisoEditar = this.permisos.editar
                        this.DatosEditarTipoVehiculo = response.data
                        this.EstadoCircularProgress = false
                        this.AbrirDialogoRegistrarTipoVehiculo = true
                    }else{
                        this.ArrayTiposVehiculos = response.data
                    }
                }else if(response.status === 400){
                    showMessageError('Error 400','Petición mala')
                    this.loadingEliminarTipoVehiculo = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 401){
                    showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')
                    this.loadingEliminarTipoVehiculo = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 404){
                    showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                    this.loadingEliminarTipoVehiculo = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }else if(response.status === 500){
                    showMessageError('Error 500','Error en el servidor')            
                    this.loadingEliminarTipoVehiculo = false
                    this.loading = false
                    this.EstadoCircularProgress = false
                }
            },

        // obtenemos todas los tipos de vehículos
            async TodosTiposVehiculos(){
                this.loading = true
                const response = await this.$store.dispatch('AllTypesOfVehicules')
                // controlamos las excepciones
                this.ControllerException(response)            
            },
        //metodos para registrar un nuevo tipo de vehiculo
            AbrirModalRegistrarTipoVehiculo(){
                if(this.permisos.crear) this.EstadoPermisoEditar = this.permisos.crear
                this.esNuevo = true
                this.TituloDialogo = "Crear"
                this.AbrirDialogoRegistrarTipoVehiculo = true
            },
            CerrarModalRegistrarTipoVehiculo(){
                this.TituloDialogo = ''
                this.AbrirDialogoRegistrarTipoVehiculo = false
            },
        //metodos para eliminar un tipo de vehiculo
            AbrirModalEliminarTipoVehiculo(item){
                this.TituloDialogo = "eliminar"
                this.tituloMensajeEliminar = item.nombre
                this.IdTipoVehiculo = item.idTipoVehiculo
                this.DialogoMensajeEliminar = true
            },
            CerrarDialogoMensajeEliminar(){
                this.DialogoMensajeEliminar = false
            },
            async EliminarTipoVehiculo(){
                this.loadingEliminarTipoVehiculo = true
                const response = await this.$store.dispatch('DeleteTypeVehicle', this.IdTipoVehiculo)
                this.ControllerException(response)
            },
        // metodos para editar un tipo de vehiculo
            async AbrirModalEditarTipoVehiculo(item){
                this.EstadoCircularProgress = true
                const response = await this.$store.dispatch('GetTypeVehicleById', item.idTipoVehiculo)
                this.esNuevo = false
                this.TituloDialogo = "Editar"
                this.ControllerException(response)
            }
    },
}
</script>